export const TOKEN_LOCAL_STORAGE_KEY = 'evidia-token';

export const BASE_API = import.meta.env.VITE_BASE_URL;
export const BASE_WS = import.meta.env.VITE_BASE_URL_SOCKET;
